import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Countdown from 'react-countdown'
import ConfigContext from '../../contexts/configContext'

const EndTimeAwareButton = ({ disabled, element: Child, endsAt, type, ...props }) => {
  const { timeOffset } = useContext(ConfigContext)
  return endsAt
    ? (<Countdown
        date={endsAt + timeOffset}
        key={`countdown-${endsAt}--${type}-button`}
        renderer={({ completed }) => (
          <Child
            {...props}
            disabled={completed || disabled}
          />
        )}
      />)
    : (<Child
        {...props}
        disabled={disabled}
      />)
}

EndTimeAwareButton.propTypes = {
  disabled: PropTypes.bool,
  element: PropTypes.elementType.isRequired,
  endsAt: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired
}

export default EndTimeAwareButton
